import { type Region } from '@/navbar/navbar.types'

export const ASSIST_DOMAINS: Record<Region, string> = {
  test:    'https://assist.platform.test.ecoonline.net',
  staging: 'https://assist.platform.staging.ecoonline.net',
  eu:      'https://assist.platform.eu.ecoonline.com',
  us:      'https://assist.platform.us.ecoonline.com',
  ca:      'https://assist.platform.ca.ecoonline.com',
  uk:      'https://assist.platform.uk.ecoonline.com',
  au:      'https://assist.platform.au.ecoonline.com',
}
